import request from '@/utils/request';
const path = '/material/label';

/** 获取素材标签列表接口 */
export function getMaterialLabelApi(params) {
  return request({
    url: `${path}`,
    method: 'get',
    params,
  });
}

/** 新增素材标签接口 */
export function addMaterialLabelApi(data) {
  return request({
    url: `${path}`,
    method: 'post',
    data,
  });
}

/** 编辑素材标签接口 */
export function editMaterialLabelApi(id, data) {
  return request({
    url: `${path}/${id}`,
    method: 'put',
    data,
  });
}

/** 删除素材标签接口 */
export function deleteMaterialLabelApi(id) {
  return request({
    url: `${path}/${id}`,
    method: 'delete',
  });
}

/** 素材标签选择器接口 */
export function getMaterialLabelSelectorApi(params) {
  return request({
    url: `${path}/selector`,
    method: 'get',
    params,
  });
}
